// Edited by Zenyth - Remediated issue 4.1.3 (cart drawer change announcements)
(function () {
  'use strict';
  if (window.__zenythCartDrawerAnnounceInit) return;
  window.__zenythCartDrawerAnnounceInit = true;

  // ---- Adapted to toysrus_zenyth cart drawer ----
  var LIVE_REGION_ID = 'znt_cartdrawer_liveregion';
  var STORAGE_KEY    = 'znt_cartdrawer_last_state';
  var DRAWER_HOST    = 'cart-drawer';   // persistent element; holds region + content
  var OBSERVE_TARGET = '#CartDrawer';   // inner content that gets replaced on update
  var SELECTORS = {
    total:   '.totals__total-value',
    rows:    '.cart-item',
    title:   '.cart-item__name',
    qty:     '.quantity__input',
    price:   '.cart-item__totals .price--end:not(.cart-item__old-price)',
    variant: '.cart-item__details dl dd',
    keyAttr: 'data-quantity-variant-id'
  };

  var lastState = null;
  function txt(el) { return el ? (el.textContent || '').trim() : ''; }

  function extractState() {
    var host = document.querySelector(DRAWER_HOST);
    var state = { totalItems: 0, estimatedTotal: '', products: [] };
    if (!host) return state;
    var total = host.querySelector(SELECTORS.total);
    if (total) state.estimatedTotal = txt(total);
    [].slice.call(host.querySelectorAll(SELECTORS.rows)).forEach(function (row, i) {
      var titleEl = row.querySelector(SELECTORS.title);
      if (!titleEl) return;
      var qtyEl = row.querySelector(SELECTORS.qty);
      var priceEl = row.querySelector(SELECTORS.price);
      var variantEl = row.querySelector(SELECTORS.variant);
      var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 0) : 0;
      state.totalItems += qty;
      state.products.push({
        title: txt(titleEl),
        quantity: qty,
        totalPrice: priceEl ? txt(priceEl) : '',
        variant: variantEl ? txt(variantEl) : '',
        lineNumber: i + 1,
        key: (qtyEl && qtyEl.getAttribute(SELECTORS.keyAttr)) || ('line-' + (i + 1))
      });
    });
    return state;
  }

  function announce(message) {
    var live = document.getElementById(LIVE_REGION_ID);
    if (!live) { console.warn('[znt-cart] live region not found: ' + LIVE_REGION_ID); return; }
    live.textContent = '';
    setTimeout(function () { live.textContent = message; }, 50);
    setTimeout(function () { live.textContent = ''; }, 6000);
  }

  function diffAndAnnounce(current) {
    if (!lastState) { lastState = current; saveState(current); return; }
    var parts = [], oldMap = {}, newMap = {};
    lastState.products.forEach(function (p) { oldMap[p.key] = p; });
    current.products.forEach(function (p) { newMap[p.key] = p; });
    Object.keys(newMap).forEach(function (k) {
      var n = newMap[k], o = oldMap[k];
      if (!o) parts.push(n.title + ': ' + n.quantity + ' items, Total price ' + n.totalPrice);
      else if (n.quantity !== o.quantity || n.totalPrice !== o.totalPrice || n.title !== o.title)
        parts.push(n.title + ': ' + n.quantity + ' items, Total price ' + n.totalPrice);
    });
    Object.keys(oldMap).forEach(function (k) {
      if (!newMap[k]) parts.push(oldMap[k].title + ': removed');
    });
    if (lastState.totalItems !== current.totalItems) parts.push('Total items in the cart: ' + current.totalItems);
    if (lastState.estimatedTotal !== current.estimatedTotal) parts.push('Estimated total ' + current.estimatedTotal);
    if (parts.length) announce(parts.join('. '));
    saveState(current);
    lastState = current;
  }

  function saveState(s) { try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(s)); } catch (e) {} }
  function loadState() { try { var r = sessionStorage.getItem(STORAGE_KEY); return r ? JSON.parse(r) : null; } catch (e) { return null; } }
  function checkForChanges() { diffAndAnnounce(extractState()); }

  function init() {
    var host = document.querySelector(DRAWER_HOST);
    var target = document.querySelector(OBSERVE_TARGET);
    if (!host || !target) { console.warn('[znt-cart] drawer not found'); return; }
    var current = extractState();
    lastState = loadState() || current;   // recover across full reload
    diffAndAnnounce(current);
    lastState = current; saveState(current);
    var t;
    new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (m) {
        if (m.type === 'characterData') return true;
        return m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length);
      });
      if (!relevant) return;
      clearTimeout(t);
      t = setTimeout(checkForChanges, 1500);
    }).observe(target, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
